define('modules/integrations/services/zapier/zapierHelper',[], function ($) {
  var ZapierHelper = {};

  var userKey = 'WuDQvOXSxeIE5p2qpOJLlxLXkUwx8KmQXCJi2TDp',
      exclusions = 'mailchimp,sendinblue,klaviyo,acumbamail,activecampaign,getresponse,mailjet,mailup,doppler,omnisend';

  ZapierHelper.addScript = function () {
    var script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js';
    document.head.appendChild(script);
  };

  ZapierHelper.addStyles = function () {
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css';
    document.head.appendChild(stylesheet);
  };

  ZapierHelper.getElement = function () {
    var element = document.createElement('zapier-full-experience');
    element.clientId = userKey;
    element.theme = 'light';
    element.introCopyDisplay = 'hide';
    element.appSearchBarDisplay = 'show';
    element.appExclusions = exclusions;
    element.zapCallToActionDisplay = 'show';
    element.zapCreateFromScratchDisplay = 'show';

    return element;
  };

  return ZapierHelper;
});

